import LocalSessionMixin from './LocalSessionMixin';

export default {
  mixins: [LocalSessionMixin],
  methods: {
    navigateTo(routeName, params = {}, others = {}) {
      this.setSessionItem('listQuery', this.getQueryParams());
      return this.$router.push({
        name: routeName,
        params: {
          ...params,
        },
        ...others,
      });
    },
    updateQueryParams(params) {
      this.$route.query.page = 1;
      this.$router.push({
        query: {
          ...this.prepareParamsToSystem(
            this.overrideQueryParams(params),
          ),
        },
      }).catch(() => {});
    },
    overrideQueryParams(params = {}) {
      const { query } = this.$route;
      const override = { ...query, ...params };
      Object.keys(override)
        .forEach((key) => {
          if (!override[key]) {
            delete override[key];
          }
        });
      return override;
    },
    getQueryParams(defaultParams = {
      PerPage: 15,
      Page: 1,
    }) {
      if (this.disableSetQueryString) {
        return {
          ...this.prepareParamsToSystem({
            ...defaultParams,
            ...this.queryPaginate,
          }),
        };
      }
      return {
        ...this.prepareParamsToSystem({
          ...defaultParams,
          ...this.$route.query,
        }),
      };
    },
    prepareParamsToSystem(params = {}) {
      return Object.keys(params)
        .reduce(
          (obj, key) => {
            const overrideParams = [
              ['page', this.isTecfin ? 'page' : 'Page'],
              ['perpage', this.isTecfin ? 'size' : 'PerPage'],
            ];
            const [, override] = overrideParams.find(
              ([p]) => key.toLocaleLowerCase() === p,
            ) || ['', key];

            return {
              ...obj,
              [override]: params[key],
            };
          },
          {},
        );
    },
    clearQueryParams() {
      const params = this.getQueryParams();
      const override = {};
      Object.keys(params)
        .forEach((key) => {
          override[key] = '';
        });
      this.updateQueryParams(override);
    },
  },
};
